{
    "locale": "fr-FR",
    "General": {
        "OrText": "Ou",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Accéder à My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Créer un nouveau compte",
        "ButtonText_SignInToYourAccount": "Se connecter à votre compte",
        "ButtonText_StartInterviewWithoutSigningUp": "Commencer l'entretien sans s'inscrire",
        "ButtonText_StartInterviewWithoutSigningIn": "Commencer l'entretien sans se connecter",
        "Navlink_Dashboard": "Tableau de bord",
        "Navlink_MyInterviews": "Mes entretiens",
        "Navlink_LearnWithHubert": "Apprendre avec Hubert",
        "Navlink_HelpCenter": "Centre d'aide",
        "MyProfile": "Mon profil",
        "LogOut": "Se déconnecter"
    },
    "Login": {
        "MainTitle": "Consultez les résultats de votre entretien Hubert",
        "Subtitle": "Connectez-vous pour voir les résultats, obtenir des retours, lire des conseils, et bien plus encore.",
        "LoginTitle": "Connectez-vous à votre compte Hubert",
        "Label_Email": "E-mail",
        "Label_Password": "Mot de passe",
        "ButtonText_SignIn": "Se connecter",
        "ButtonText_ForgotPassword": "Mot de passe oublié ?",
        "ButtonText_ContinueWithGoogle": "Continuer avec Google",
        "OrSeparator": "Ou",
        "Error_Email_Required": "L'e-mail est requis.",
        "Error_Email_Invalid": "Entrez un e-mail valide.",
        "Error_Password_Required": "Le mot de passe est requis.",
        "Error_Use_Same_Email_As_Interview": "Veuillez utiliser le même e-mail que celui utilisé pour l'entretien."
    },
    "Registration": {
        "MainTitle": "Consultez les résultats de votre entretien Hubert",
        "Subtitle": "Inscrivez-vous pour voir les résultats, obtenir des retours, lire des conseils, et bien plus encore.",
        "RegistrationTitle": "Créer un compte Hubert",
        "BenefitsBox_Title": "Vous pouvez",
        "BenefitsBox_Point1": "Accéder à l'historique de vos entretiens",
        "BenefitsBox_Point2": "Recevoir des retours sur vos entretiens",
        "BenefitsBox_Point3": "Réutiliser vos réponses dans de nouveaux entretiens",
        "BenefitsBox_Point4": "Recevoir des conseils pour les entretiens",
        "BenefitsBox_Point5": "Lire des guides de carrière",
        "BenefitsBox_Point6": "Et bien plus encore",
        "Label_FirstName": "Prénom",
        "Label_LastName": "Nom",
        "Label_Email": "E-mail",
        "Label_Password": "Mot de passe",
        "Label_PhoneNumber": "Numéro de téléphone",
        "Label_TermsOfService": "J'accepte les",
        "Label_TermsOfServiceLink": "Politique de confidentialité et Conditions générales",
        "Placeholder_CountryCode": "Sélectionnez le code du pays",
        "Placeholder_PhoneNumber": "Ex. 0612345678",
        "HelpText_Password": "Le mot de passe doit comporter au moins 6 caractères.",
        "ButtonText_SignUp": "S'inscrire",
        "ButtonText_SignUpWithGoogle": "S'inscrire avec Google",
        "OrSeparator": "Ou",
        "Error_FirstName_Required": "Le prénom est requis.",
        "Error_LastName_Required": "Le nom est requis.",
        "Error_Email_Required": "L'e-mail est requis.",
        "Error_Email_Invalid": "Entrez un e-mail valide.",
        "Error_Email_Exists": "L'e-mail est déjà pris.",
        "Error_Password_Required": "Le mot de passe est requis.",
        "Error_Password_6_Characters": "Votre mot de passe doit comporter au moins 6 caractères.",
        "Error_PhoneNumber_Required": "Le numéro de téléphone est requis.",
        "Error_PhoneNumber_Invalid": "Le numéro de téléphone n'est pas valide.",
        "Error_PrivacyPolicyCheck_Required": "La politique de confidentialité et les conditions générales doivent être acceptées."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Pour passer l'entretien, veuillez accepter les conditions d'utilisation de Hubert. Cochez simplement la case pour continuer.",
        "Subtitle_AfterInterviewCompleted": "Inscrivez-vous pour voir les résultats, obtenir des retours, lire des conseils, et bien plus encore.",
        "PrivacyPolicyText": "En appuyant sur s'inscrire, vous acceptez la",
        "PrivacyPolicyLink": "Politique de confidentialité et Conditions générales",
        "ButtonText_SignUp": "S'inscrire et aller à l'entretien",
        "ButtonText_SignUpNormal": "S'inscrire",
        "ButtonText_SignInInstead": "Cliquez ici pour vous connecter à la place"
    },
    "LoginInviteEmail": {
        "Subtitle": "Connectez-vous pour voir les résultats, obtenir des retours, lire des conseils, et bien plus encore."
    },
    "AppMessages": {
        "internal-server-error": "Une erreur inattendue s'est produite.",
        "invalid-credentials": "Identifiants invalides. Veuillez réessayer.",
        "user-not-found": "Identifiants invalides. Veuillez réessayer.",
        "account-not-found": "Compte invalide. Veuillez réessayer.",
        "verify-email-title": "Vérifiez votre e-mail",
        "verify-email-subtitle": "Veuillez vérifier votre e-mail pour valider votre compte.",
        "email-not-verified-title": "E-mail non vérifié",
        "email-not-verified-subtitle": "Veuillez vérifier votre e-mail pour valider votre compte.",
        "verifying-email-title": "Vérification de l'e-mail",
        "verifying-email-subtitle": "Veuillez patienter...",
        "sign-in-title": "Connexion",
        "sign-in-subtitle": "Veuillez patienter...",
        "server-error": "Un problème est survenu.",
        "hubert-user-exists": "Le compte existe déjà.",
        "account-exists": "Le compte existe déjà.",
        "email-verified": "Votre e-mail a été vérifié.",
        "email-is-taken": "L'e-mail est déjà pris.",
        "re-enter-password": "Utilisez votre mot de passe pour vous connecter",
        "password-reset": "Votre mot de passe a été changé.",
        "re-enter-new-password": "Utilisez votre nouveau mot de passe pour vous connecter",
        "invalid-invitation": "Invitation invalide.",
        "invalid-code": "Code de vérification invalide.",
        "email-already-verified": "L'e-mail est déjà vérifié.",
        "email-mismatch-title": "Incohérence d'e-mail",
        "email-mismatch-subtitle": "Veuillez utiliser le même e-mail que celui utilisé pour postuler."
    },
    "TransitionPage": {
        "loading-title": "Chargement...",
        "loading-subtitle": "Préparation de vos données...",
        "logout-title": "Chargement...",
        "logout-subtitle": "Déconnexion en cours..."
    },
    "ImpersonationPage": {
        "loading-title": "Chargement...",
        "loading-subtitle": "Préparation de vos données..."
    },
    "ProcessInvitation": {
        "loading-title": "Chargement...",
        "loading-subtitle": "Veuillez patienter pendant le chargement de votre entretien.",
        "InvitationNotFound": "Nous ne trouvons pas votre entretien.",
        "InvitationExpired": "Ce lien pour accéder à l'entretien a expiré.",
        "InvitationExpired_Description1": "Veuillez ouvrir l'entretien depuis.",
        "InvitationExpired_Description2": "ou contactez votre recruteur.",
        "InvitationInvalid": "Le lien vers cette invitation est invalide.",
        "InterviewCompleted": "Cet entretien a déjà été complété."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mes entretiens",
            "TableHead_Employer": "Employeur",
            "TableHead_Job": "Poste",
            "TableHead_Status": "Statut",
            "TableHead_ApplicationDate": "Date de candidature",
            "TableBody_StartInterview": "L'entretien n'est pas terminé. Cliquez ici pour commencer ou reprendre.",
            "TableBody_NotScored": "L'entretien est terminé. Les résultats seront bientôt disponibles.",
            "TableBody_Details": "Cliquez ici pour voir les résultats et plus encore.",
            "ApplicationDate_Invited": "Invité",
            "ApplicationDate_MinuteAgo": "minute écoulée",
            "ApplicationDate_MinutesAgo": "minutes écoulées",
            "ApplicationDate_HourAgo": "heure écoulée",
            "ApplicationDate_HoursAgo": "heures écoulées",
            "ApplicationDate_DayAgo": "jour écoulé",
            "ApplicationDate_DaysAgo": "jours écoulés",
            "ButtonText_SeeAllInterviews": "Voir tous les entretiens",
            "ButtonText_Details": "Détails",
            "ButtonText_StartInterview": "Aller à l'entretien",
            "ButtonText_NotScored": "Résultats en attente",
            "NoInterviews_Message": "Il n'y a pas d'enregistrements d'entretiens pour vous."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Il n'y a pas d'offres d'emploi pour le moment. Veuillez vérifier plus tard."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Ma carrière",
            "Subtitle": "Sélectionnez un entretien pour voir l'évaluation et vos perspectives.",
            "MostRecentInterview": "Entretien le plus récent",
            "ToDo": "À faire",
            "NoOngoingInterviews_Title": "Aucune nouvelle invitation à un entretien.",
            "NoOngoingInterviews_Subtitle": "Les nouveaux entretiens Hubert apparaîtront ici une fois programmés par les recruteurs.",
            "NoRecentInterviews_Title": "Aucun enregistrement d'entretien précédent.",
            "NoRecentInterviews_Subtitle": "Une fois invité à un entretien, il apparaîtra ci-dessous.",
            "ButtonText_StartInterview": "Aller à l'entretien",
            "ButtonText_NotScored": "Résultats en attente",
            "ButtonText_Details": "Détails"
        },
        "LearnWithHubert": {
            "Title": "Apprendre avec Hubert",
            "Subtitle": "Obtenez des conseils pour améliorer vos compétences en entretien et au travail.",
            "PickedForMe": "Derniers articles",
            "ButtonText_SeeAllArticles": "Voir tous les articles"
        },
        "HubertTip": {
            "Title": "Astuce Hubert",
            "Subtitle": "Passez vos entretiens plus rapidement",
            "Description": "Vous postulez pour un poste similaire à celui d'un précédent entretien Hubert ? Vous pouvez réutiliser vos réponses pour gagner du temps.",
            "ButtonText_ReadMoreTips": "Lire plus de conseils"
        },
        "NewCandidateModalPopup": {
            "Title": "Tout est prêt !",
            "DescriptionLine1": "Votre compte est maintenant prêt.",
            "DescriptionLine2": "Gérez vos entretiens et votre profil. Consultez vos résultats, obtenez des retours et apprenez-en davantage sur les entretiens.",
            "ButtonText_LetsGo": "Allons-y"
        },
        "InterviewCompletedModal": {
            "Title": "Bon travail !",
            "Subtitle": "Vous avez terminé votre entretien.",
            "Description": "Les recruteurs examineront toutes les candidatures et fourniront un retour par e-mail ou téléphone dès qu'ils auront des nouvelles.",
            "ButtonText_Continue": "Continuer"
        },
        "LatestJobPostings": {
            "Title": "Dernières offres d'emploi",
            "Subtitle": "Explorez d'autres offres de nos partenaires Hubert récemment publiées."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mes entretiens",
        "MyInterviewsSection_Subtitle": "Sélectionnez un entretien pour voir l'évaluation et vos opportunités de carrière.",
        "MyInterviewsSection_ToDo": "À faire"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Voir tous les entretiens",
        "InterviewNotFound_Title": "Entretien inaccessible",
        "InterviewNotFound_Description": "Vous essayez d'accéder aux détails d'un entretien non associé à votre compte.",
        "ButtonText_GoToAllInterviews": "Aller à Mes entretiens",
        "InterviewDetails": {
            "Title": "Détails de l'entretien",
            "ForRole": "Pour le poste",
            "InterviewCompletedOn": "Entretien terminé le {{date}} à {{time}}"
        },
        "MyResult": {
            "Title": "Mon résultat",
            "Subtitle": "Correspondance évaluée",
            "ButtonText_LearnMore": "Voir comment vos réponses sont évaluées",
            "GotPotential_Title": "Bon potentiel, une exigence manque",
            "GotPotential_Description": "Vos réponses indiquent un fort potentiel pour ce type de poste. Cependant, d'après cet entretien, il se peut que vous ne remplissiez pas une ou plusieurs qualifications requises pour ce poste spécifique. Cela peut affecter la suite du processus, selon les besoins du recruteur et le nombre de candidats. Si vous ne passez pas à l’étape suivante, cela ne reflète pas nécessairement votre potentiel. Souvent, il s'agit de trouver une correspondance précise pour les besoins spécifiques du rôle. Consultez les opportunités et conseils ci-dessous.",
            "GotPotential_DescriptionSecondary": "L’évaluation de Hubert est indicative. Le recruteur prend la décision finale et d'autres facteurs, comme le nombre de candidats, peuvent également influencer le résultat.",
            "GreatMatch_Title": "Forte correspondance",
            "GreatMatch_Description": "Vos réponses correspondent bien à ce que les recruteurs recherchent généralement pour ce poste, et vous répondez aux exigences. Excellent travail. Le recruteur examinera l’ensemble des candidatures et décidera des prochaines étapes.",
            "GreatMatch_DescriptionSecondary": "L’évaluation de Hubert est indicative. Le recruteur prend la décision finale et d'autres facteurs, comme le nombre de candidats, peuvent également influencer le résultat. Si vous ne passez pas à l’étape suivante, cela ne reflète pas nécessairement votre potentiel. Souvent, il s'agit de trouver une correspondance précise pour les besoins spécifiques du rôle. Consultez les opportunités et conseils ci-dessous.",
            "OkMatch_Title": "Qualifié, ajoutez de l'impact",
            "OkMatch_Description": "Vous répondez aux exigences. Pour vous démarquer davantage, vos réponses pourraient bénéficier de plus de clarté et de spécificité. Revoyez vos réponses ci-dessous pour voir où l'ajout d'un exemple concret ou d'un résultat peut améliorer votre score.",
            "OkMatch_DescriptionSecondary": "L’évaluation de Hubert est indicative. Le recruteur prend la décision finale et d'autres facteurs, comme le nombre de candidats, peuvent également influencer le résultat.",
            "NotClearMatch_Title": "Peut-être pas le bon profil pour l'instant",
            "NotClearMatch_Description": "D’après cet entretien, vos réponses peuvent être moins alignées avec ce que le recruteur recherche, ou vous ne remplissez peut-être pas une ou plusieurs exigences. Si vous souhaitez vous améliorer, commencez par les questions ci-dessous. De petites modifications, plus de précisions et des résultats clairs peuvent faire une grande différence la prochaine fois.",
            "NotClearMatch_DescriptionSecondary": "L’évaluation de Hubert est indicative. Le recruteur prend la décision finale et d'autres facteurs, comme le nombre de candidats, peuvent également influencer le résultat."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Expériences professionnelles, motivations et compétences",
            "QualifyingRequirements": "Exigences de qualification pour ce poste spécifique",
            "NotQualified_Title": "Marge de progression",
            "NotQualified_Description": "Vos réponses ont peut-être manqué de précision ou de résultats concrets par rapport aux attentes du recruteur. Regardez ci-dessous où l'ajout d'un exemple concret, d'actions spécifiques ou d'un résultat clair peut renforcer votre réponse.",
            "GreatResults_Title": "Réponses solides",
            "GreatResults_Description": "Vos réponses indiquent que vous correspondez bien à ce type de rôle et que vous avez communiqué clairement. Si une question peut être améliorée, elle sera mise en évidence ci-dessous.",
            "MeetingRequirements_Title": "Exigences remplies",
            "MeetingRequirements_Description": "Vos réponses indiquent que vous répondez aux exigences de qualification définies pour ce poste. C'est une bonne base.",
            "NotAllExpectationsMet_Title": "Une ou plusieurs exigences manquantes",
            "NotAllExpectationsMet_Description": "D’après vos réponses, vous pourriez ne pas répondre à une ou plusieurs exigences de qualification pour ce poste spécifique, telles que des certificats, des permis, un niveau d’études ou des années d’expérience.",
            "ButtonText_FindOutPossibleReasons": "Voir les détails"
        },
        "ScriptFromInterview": {
            "Title": "Lire votre entretien complet",
            "ButtonText_SeeWholeTranscript": "Lire l'entretien",
            "ButtonText_DeleteInterview": "Supprimer l'entretien",
            "Loading_Title": "Chargement...",
            "Loading_Subtitle": "Veuillez patienter pendant le chargement de la transcription."
        },
        "HowToImproveAtInterviews": {
            "Title": "Comment s'améliorer en entretien",
            "Subtitle_Questions": "Voici quelques questions où votre réponse pourrait potentiellement être améliorée.",
            "Subtitle_NoQuestions": "Aucune réponse spécifique n'a été signalée. Voici les meilleurs moyens d'ajouter de l'impact pour ce rôle.",
            "GreatMatch_Questions_Description": "Même avec une forte correspondance, certaines réponses peuvent être renforcées. Si nous en avons identifié, vous les trouverez ci-dessous. Suivez les instructions avant chaque question. Lorsque vous décrivez une situation, incluez la situation, ce que vous avez fait et le résultat. Évitez les réponses très courtes. Visez des descriptions claires et concrètes.",
            "GreatMatch_NoQuestions_Description": "Vous avez bien répondu à vos questions. Excellent travail.",
            "OkMatch_Questions_Description": "Vous trouverez ci-dessous des questions où votre réponse pourrait être améliorée. Suivez les instructions avant chaque question. Lorsque vous décrivez une situation, incluez la situation, ce que vous avez fait et le résultat. Évitez les réponses très courtes. Visez des descriptions claires et concrètes.",
            "OkMatch_NoQuestions_Description": "Vos réponses étaient solides, mais ce rôle peut être compétitif. Cela signifie que même de bonnes réponses peuvent se situer dans la moyenne.",
            "OkMatch_NoQuestions_DescriptionSecondary": "La prochaine fois, visez la clarté et l'impact. Commencez par le résultat, ajoutez un exemple réel et restez concis, généralement 3 à 6 phrases. Soyez précis sur ce que vous avez fait, comment et ce qui a changé grâce à cela.",
            "GotPotential_Questions_Description": "Même si vous semblez être un bon candidat pour ce type de poste, certaines réponses peuvent être renforcées. Si nous en avons identifié, vous les trouverez ci-dessous. Suivez les instructions avant chaque question. Lorsque vous décrivez une situation, incluez la situation, ce que vous avez fait et le résultat. Évitez les réponses très courtes. Visez des descriptions claires et concrètes.",
            "GotPotential_NoQuestions_Description": "Nous n'avons trouvé aucune réponse nécessitant une amélioration majeure concernant les compétences professionnelles et les motivations. Vous semblez avoir bien répondu sur ces sujets.",
            "NotClearMatch_Questions_Description": "Vous trouverez ci-dessous des questions où votre réponse pourrait être améliorée. Suivez les instructions avant chaque question. Lorsque vous décrivez une situation, incluez la situation, ce que vous avez fait et le résultat. Évitez les réponses très courtes. Visez des descriptions claires et concrètes.",
            "NotClearMatch_NoQuestions_Description": "Nous n'avons trouvé aucune « mauvaise » réponse. Il s'agit davantage de l'alignement global avec les besoins du rôle. Si la concurrence est forte, de petits écarts peuvent compter.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Pour votre prochain entretien, concentrez-vous sur le concret. Choisissez un exemple par question, expliquez vos actions et partagez le résultat. Court et précis vaut généralement mieux que long et général.",
            "Alert_WantMoreAdvice": "Vous voulez plus de conseils pour réussir un entretien Hubert ?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Découvrir notre article de conseils généraux"
        },
        "SimilarOffers": {
            "Title": "Offres similaires"
        },
        "HowHubertScoresInterviews": {
            "Title": "Comment Hubert évalue-t-il les entretiens ?",
            "Description": "Voici une brève description de l'évaluation des réponses. Nous avons également ajouté une section Processus de recrutement pour expliquer les étapes suivantes.",
            "Tabs_PossibleOutcomes": "Résultats possibles",
            "Tabs_RecruitmentProcess": "Processus de recrutement",
            "AssessedMatch_Title": "Correspondance évaluée",
            "AssessedMatch_Description": "Hubert évalue comment vos réponses sont perçues par rapport à ce que les recruteurs recherchent généralement. Avec les exigences du rôle, vous verrez l'un des résultats ci-dessous.",
            "AssessedMatch_DescriptionSecondary": "L’évaluation de Hubert est indicative. Le recruteur prend la décision finale et d'autres facteurs, comme le nombre de candidats, peuvent également influencer le résultat.",
            "GreatMatch_Title": "Forte correspondance",
            "GreatMatch_Description": "Vos réponses correspondent bien à ce que les recruteurs recherchent, et vous répondez aux exigences. Excellent travail. Le recruteur examinera les candidatures et décidera des prochaines étapes.",
            "GotPotential_Title": "Bon potentiel, une exigence manque",
            "GotPotential_Description": "Vos réponses indiquent un fort potentiel. Cependant, vous ne remplissez peut-être pas une ou plusieurs qualifications requises. Cela peut affecter les étapes suivantes, selon les besoins du recruteur.",
            "OkMatch_Title": "Qualifié, ajoutez de l'impact",
            "OkMatch_Description": "Vous répondez aux exigences. Pour vous démarquer, vos réponses peuvent nécessiter plus de clarté et de spécificité. Utilisez les retours de votre entretien pour renforcer vos exemples à l'avenir.",
            "NotClearMatch_Title": "Peut-être pas le bon profil pour l'instant",
            "NotClearMatch_Description": "D’après cet entretien, vos réponses peuvent être moins alignées avec ce que le recruteur recherche, et vous ne remplissez peut-être pas une ou plusieurs exigences. Revoyez vos réponses pour voir où ajouter de la clarté et des exemples.",
            "ProfessionalExperiences_Title": "Expériences professionnelles, motivations et compétences",
            "ProfessionalExperiences_Description": "Ces questions portent sur vos expériences passées, votre motivation et les compétences pertinentes. Les recruteurs décident quelles questions sont utilisées.",
            "GreatResults_Title": "Réponses solides",
            "GreatResults_Description": "Vos réponses indiquent que vous correspondez bien à ce type de rôle et que vous avez communiqué clairement. Si une question peut être améliorée, elle sera mise en évidence.",
            "NotQualified_Title": "Marge de progression",
            "NotQualified_Description": "Vos réponses ont peut-être manqué de précision ou de résultats concrets. Cherchez les endroits mis en évidence où l'ajout d'un exemple concret ou d'un résultat clair peut renforcer vos réponses.",
            "QualifyingRequirements_Title": "Exigences de base ou qualificatives",
            "QualifyingRequirements_Description": "Ce sont des questions définies comme exigences qualificatives, par exemple un certificat requis, un permis de conduire ou un certain niveau d'expérience.",
            "MeetingRequirements_Title": "Exigences remplies",
            "MeetingRequirements_Description": "Vos réponses indiquent que vous répondez aux exigences qualificatives fixées pour ce poste. C'est une bonne base.",
            "NotAllExpectationsMet_Title": "Une ou plusieurs exigences manquantes",
            "NotAllExpectationsMet_Description": "D’après vos réponses, vous pourriez ne pas répondre à une ou plusieurs exigences de qualification pour ce poste spécifique.",
            "RecruitmentProcess_Title": "Processus de recrutement",
            "RecruitmentProcess_Description": "Hubert est souvent utilisé comme première étape. Il permet à chacun de passer un entretien et de s'exprimer. Comme les questions sont les mêmes pour tous, le processus est plus cohérent. Hubert n'utilise pas d'informations comme l'âge, le genre ou l'apparence, réduisant le risque de biais inconscient.",
            "EventOne_Title": "Vous êtes interviewé par Hubert",
            "EventOne_Description": "Vous passez l'entretien quand et où cela vous convient. Il n'y a pas de restrictions de temps, et vous pouvez faire une pause à tout moment.",
            "EventTwo_Title": "Votre entretien est évalué",
            "EventTwo_Description": "Hubert évalue vos réponses avec une technologie moderne. Dès que l'évaluation est terminée, les résultats sont visibles ici dans My Hubert et pour le recruteur.",
            "EventThree_Title": "Le recruteur sélectionne les candidats",
            "EventThree_Description": "Les recruteurs voient quand un nouveau résultat est disponible. Ils examinent vos réponses et l'évaluation de Hubert. Sur la base de l'évaluation indicative et de leur jugement, ils décident si vous serez invité à l'étape suivante (appel, test, entretien final). Si d'autres candidats correspondent mieux, il est possible que vous ne passiez pas à l’étape suivante.",
            "ButtonText_Close": "Fermer"
        }
    },
    "MyProfile": {
        "Title": "Mon profil",
        "MyDetails": {
            "Title": "Mes détails",
            "Label_FirstName": "Prénom",
            "Label_LastName": "Nom",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Numéro de téléphone",
            "ButtonText_UpdateDetails": "Mettre à jour les détails",
            "Error_FirstName_Required": "Le prénom est requis.",
            "Error_LastName_Required": "Le nom est requis.",
            "Error_Email_Required": "L'e-mail est requis.",
            "Error_Email_Invalid": "Entrez un e-mail valide.",
            "Error_PhoneNumber_Invalid": "Le numéro de téléphone n'est pas valide.",
            "Success_Details_Updated": "Profil mis à jour."
        },
        "ChangePassword": {
            "Title": "Changer le mot de passe",
            "Set_Password_Title": "Créer un mot de passe",
            "Label_CurrentPassword": "Mot de passe actuel",
            "Label_NewPassword": "Nouveau mot de passe",
            "Label_RepeatNewPassword": "Répétez le nouveau mot de passe",
            "Alert_SignInAgain": "Veuillez vous reconnecter pour définir votre mot de passe.",
            "ButtonText_UpdatePassword": "Mettre à jour le mot de passe",
            "ButtonText_SetPassword": "Définir le mot de passe",
            "ButtonText_SignInAgain": "Se reconnecter",
            "Error_CurrentPassword_Required": "Le mot de passe actuel est requis.",
            "Error_CurrentPassword_DoesntMatch": "Le mot de passe ne correspond pas au mot de passe actuel.",
            "Error_NewPassword_Required": "Le nouveau mot de passe est requis.",
            "Error_NewPassword_6_Characters": "Votre nouveau mot de passe doit comporter au moins 6 caractères.",
            "Error_RepeatNewPassword_Required": "La répétition du mot de passe est requise.",
            "Error_RepeatNewPassword_DoesntMatch": "Le mot de passe ne correspond pas au nouveau mot de passe.",
            "Success_Password_Changed": "Mot de passe mis à jour.",
            "Error_Invalid_CurrentPassword": "Mot de passe actuel invalide."
        },
        "NotificationPreferences": {
            "Title": "Préférences de notification",
            "Label_ReceiveUpdatesToggle": "Je souhaite recevoir les mises à jour de Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Vous recevrez des guides de carrière, des conseils d'entretien et plus encore."
        },
        "AccountRemoval": {
            "Title": "Suppression de compte",
            "ButtonText_RemoveMyAccount": "Supprimer mon compte"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Bonjour",
        "Subtitle": "Vous êtes sur le point de commencer votre entretien.",
        "TipBox_Title": "Voici quelques conseils pour réussir.",
        "TipBox_Tip1": "Faites l'entretien dans un endroit calme pour vous concentrer.",
        "TipBox_Tip2": "Utilisez un ordinateur avec un clavier si possible.",
        "TipBox_Tip3": "Soyez aussi précis et détaillé que possible. Hubert et les recruteurs veulent bien vous connaître.",
        "TipBox_Tip4": "Prenez le temps qu’il faut. Il n’y a pas de limite de temps.",
        "TipBox_Tip5": "Vous pouvez faire une pause et reprendre plus tard.",
        "TipBox_Tip6": "Soyez vous-même et engagez-vous comme dans un entretien réel.",
        "CheckAdviceArticle_Text1": "Si vous voulez plus de conseils pour réussir l'entretien, consultez cet",
        "CheckAdviceArticle_Text2": "article",
        "CheckAdviceArticle_Text3": "plein de bons conseils.",
        "ReadyToGetStarted": "Êtes-vous prêt à commencer ?",
        "ORSeparator_Text": "Ou",
        "ButtonText_StartInterviewNow": "Commencer l'entretien",
        "ButtonText_SetReminder": "Pas prêt, programmer un rappel",
        "PrivacyPolicyText": "En appuyant sur commencer l'entretien, vous acceptez la",
        "PrivacyPolicyLink": "Politique de confidentialité et Conditions générales"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Bon travail !",
        "CompletedAlert_Subtitle": "Vous avez terminé votre entretien.",
        "CompletedAlert_Description": "Les recruteurs examineront toutes les candidatures et fourniront un retour par e-mail ou téléphone dès qu'ils auront des nouvelles.",
        "InterviewNotCompleted": "Cet entretien n'est pas terminé."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centre d'aide",
            "Subtitle": "Trouvez les réponses aux questions les plus fréquentes sur Hubert.",
            "Label_Search": "rechercher les questions fréquentes",
            "ButtonText_Search": "Rechercher"
        },
        "FAQSection": {
            "Tabs_All": "Toutes",
            "Tabs_AboutHubertInterview": "À propos de l'entretien Hubert",
            "Tabs_TechnicalSupport": "Support technique"
        },
        "StillHaveQuestion": {
            "Title": "Vous avez encore une question ?",
            "Description": "Nous sommes heureux de vous aider.",
            "DropUsAEmail": "Envoyez-nous un e-mail à hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Puis-je passer mon entretien par téléphone ?",
                    "a": "Hubert fonctionne uniquement par chat. Si une condition médicale vous en empêche, veuillez contacter directement l'entreprise."
                },
                {
                    "q": "Puis-je passer l'entretien dans une autre langue ?",
                    "a": "Pour certains entretiens, le choix de la langue est possible au début. Sinon, la langue est probablement une exigence du poste. Contactez l'entreprise pour plus de détails."
                },
                {
                    "q": "Serai-je pénalisé pour des réponses courtes ?",
                    "a": "Non, tant que vous répondez de manière appropriée. Les détails aident souvent."
                },
                {
                    "q": "Puis-je réutiliser mes réponses d'un autre entretien ?",
                    "a": "Oui, si vous êtes connecté à My Hubert et postulez pour un rôle similaire."
                },
                {
                    "q": "Un humain lira-t-il mon entretien ?",
                    "a": "Oui, nos clients vérifient manuellement les entretiens."
                },
                {
                    "q": "J'ai passé l'entretien, que se passe-t-il maintenant ?",
                    "a": "Les résultats sont envoyés au recruteur. Ils examineront vos réponses et l'évaluation. Ils décideront ensuite de la prochaine étape (appel, test, entretien final)."
                },
                {
                    "q": "J'ai une question sur les prochaines étapes, à qui m'adresser ?",
                    "a": "Veuillez contacter l'entreprise où vous avez postulé."
                },
                {
                    "q": "Comment évitez-vous les biais dans le recrutement ?",
                    "a": "Hubert est cohérent et ne connaît ni le genre, ni l'âge, ni l'origine, réduisant les biais courants."
                },
                {
                    "q": "Puis-je être interviewé par un humain ?",
                    "a": "Veuillez contacter l'entreprise pour cette demande."
                },
                {
                    "q": "Hubert est-il humain ?",
                    "a": "Non, Hubert est un système informatique."
                },
                {
                    "q": "Puis-je changer mes réponses après ?",
                    "a": "Non, une fois soumises, les réponses ne peuvent être modifiées."
                },
                {
                    "q": "Comment réussir l'entretien Hubert ?",
                    "a": "Lisez attentivement, suivez les instructions, donnez des exemples réels et soyez honnête."
                },
                {
                    "q": "J'ai besoin d'un emploi, qui contacter ?",
                    "a": "Contactez l'entreprise où vous avez postulé."
                },
                {
                    "q": "Je n'ai pas eu de nouvelles après l'entretien. Que faire ?",
                    "a": "Les recruteurs décident des étapes suivantes. Si d'autres candidats correspondent mieux, ils peuvent ne pas donner suite. Vous pouvez contacter le recruteur pour vérifier."
                },
                {
                    "q": "J'ai de l'expérience, mais je n'ai pas eu le poste. Pourquoi ?",
                    "a": "La concurrence peut être forte. Vous pouvez demander un retour à l'entreprise ou consulter My Hubert pour des conseils."
                },
                {
                    "q": "Combien de temps dure l'entretien ?",
                    "a": "Entre 10 et 25 minutes selon les questions. Ne vous précipitez pas."
                },
                {
                    "q": "Où lire comment mes données sont traitées ?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Pourquoi je ne vois pas mes entretiens précédents ?",
                    "a": "Assurez-vous d'utiliser le même e-mail que pour votre candidature (y compris pour la connexion Google)."
                },
                {
                    "q": "Pourquoi n'ai-je pas reçu d'e-mail ?",
                    "a": "Vérifiez vos spams. Ou créez un compte My Hubert avec votre e-mail de candidature pour trouver le lien."
                },
                {
                    "q": "Je ne trouve pas le lien dans mon e-mail.",
                    "a": "Vérifiez vos spams. Ou connectez-vous à My Hubert et allez dans 'Mes entretiens'."
                },
                {
                    "q": "L'entretien fonctionne-t-il sur mobile ?",
                    "a": "Oui, mais un ordinateur peut être plus confortable pour écrire."
                },
                {
                    "q": "L'entretien ne fonctionne pas, que faire ?",
                    "a": "Envoyez un e-mail à hubert@hubert.ai."
                },
                {
                    "q": "Je veux supprimer mon compte, que faire ?",
                    "a": "Envoyez un e-mail à hubert@hubert.ai."
                },
                {
                    "q": "L'entretien a été interrompu, comment revenir ?",
                    "a": "Cliquez sur le lien dans l'e-mail ou connectez-vous à My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Apprendre avec Hubert",
            "Subtitle": "Découvrez comment augmenter vos chances et mieux performer au travail.",
            "Label_Search": "rechercher des guides",
            "ButtonText_Search": "Rechercher"
        },
        "TabSelector": {
            "MyFeed": "Mon flux",
            "InterviewGuides": "Guides d'entretien",
            "CareerGuides": "Guides de carrière"
        },
        "NewestOnTheFeed": "Les plus récents",
        "PickedForMe": "Derniers articles",
        "InterviewGuides": "Guides d'entretien",
        "CareerGuides": "Guides de carrière"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Retour à tous les articles"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Réinitialiser le mot de passe",
        "ResetLinkAlert_Subtitle": "Cliquez sur le lien reçu par e-mail pour définir un nouveau mot de passe.",
        "PasswordNotSetAlert_Message": "Mot de passe non défini, connectez-vous avec",
        "ResetYourPassword": {
            "MainTitle": "Consultez les résultats de votre entretien Hubert",
            "Subtitle": "Connectez-vous pour voir les résultats, obtenir des retours, lire des conseils, et bien plus encore.",
            "FormSectionTitle": "Réinitialisez votre mot de passe",
            "Label_NewPassword": "Nouveau mot de passe",
            "Label_ConfirmNewPassword": "Confirmer le nouveau mot de passe",
            "Error_NewPassword_Required": "Veuillez entrer un nouveau mot de passe.",
            "Error_Password_6_Characters": "Votre nouveau mot de passe doit comporter au moins 6 caractères.",
            "Error_ConfirmNewPassword_Required": "Vous devez confirmer votre nouveau mot de passe.",
            "Error_ConfirmNewPassword_NotMatch": "Le mot de passe ne correspond pas au nouveau mot de passe.",
            "Error_MalformedResetUrl": "Code de sécurité invalide. Veuillez réessayer.",
            "Error_ResetPasswordFailed": "Problème lors de la réinitialisation. Veuillez réessayer.",
            "Error_WeakPassword": "Le mot de passe doit contenir au moins 6 caractères.",
            "Error_InvalidCode_Title": "Votre demande est expirée ou invalide.",
            "Error_InvalidCode_Subtitle": "Veuillez réessayer de réinitialiser votre mot de passe.",
            "ButtonText_SetNewPassword": "Définir et se connecter",
            "ButtonText_RememberYourPassword": "Vous vous souvenez de votre mot de passe ?",
            "ButtonText_SignInInstead": "Se connecter"
        }
    },
    "PageNotFound": {
        "Title": "Page non trouvée",
        "Description": "Nous ne trouvons pas la page que vous cherchez.",
        "ButtonText_GoToDashboard": "Aller au tableau de bord",
        "ButtonText_GoToLogin": "Aller à la connexion"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "La réutilisation des réponses n'est pas encore disponible pour cet entretien. Nous espérons qu'elle le sera bientôt, mais vous pouvez passer l'entretien maintenant.",
        "DescriptionLine2": "Veuillez procéder à l'entretien en cliquant sur le bouton ci-dessous.",
        "ButtonText_TakeMeToTheInterview": "Aller à l'entretien"
    },
    "UnsubscribeFromEmails": {
        "Title": "Êtes-vous sûr ?",
        "Subtitle": "Vous ne recevrez plus d'e-mails pour ce poste :",
        "SelectTheReason": "Veuillez sélectionner une raison.",
        "ReasonText1": "J'ai trouvé un autre travail.",
        "ReasonText2": "Je ne suis plus intéressé par ce poste.",
        "ReasonText3": "Autre",
        "ButtonText_Unsubscribe": "Se désabonner",
        "Placeholder_YourReason": "Votre raison",
        "Success_Title": "Vous vous êtes désabonné avec succès.",
        "Loading": "Chargement...",
        "Error_YourReason_Required": "Veuillez entrer une raison.",
        "Error_ServerIssue": "La désinscription n’a pas abouti."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Réessayer"
    },
    "Outreach": {
        "CandidateNotFound": "Candidat non trouvé",
        "CandidateNotFoundDesc": "Nous n'avons pas pu trouver les détails de l'entretien que vous recherchez.",
        "InterviewEnded": "Entretien terminé",
        "InterviewEndedDesc1": "Cette session d'entretien est terminée ou n'est plus disponible.",
        "InterviewEndedDesc2": "Merci de votre temps. Si vous avez des questions, veuillez contacter l'équipe de recrutement.",
        "ReadyTitle": "Êtes-vous prêt pour votre entretien, {{firstName}} ?",
        "InvitationDesc": "Hubert, au nom de {{companyName}}, vous invite à un entretien par chat qui dure environ 1 à 2 minutes.",
        "Button_StartChat": "Commencer l'entretien par chat",
        "CancelNotice": "Commencer ici annulera l'appel prévu pour ce poste.",
        "PreferNotToContinue": "Vous préférez ne pas continuer ?",
        "DeclineLabel": "Ce poste ne m'intéresse pas. Ne plus m'appeler ou m'envoyer de messages pour ce poste.",
        "Button_ConfirmAndDecline": "Confirmer et refuser",
        "Processing": "Traitement en cours...",
        "Toast_DeclineSuccess": "Entretien refusé avec succès",
        "Toast_CancelVoiceInfo": "Entretien vocal annulé. Fonctionnalité bientôt disponible.",
        "Toast_CancelError": "Échec de l'annulation de l'entretien. Veuillez réessayer.",
        "Footer_WithdrawConsent": "Vous pouvez retirer votre consentement à tout moment. En savoir plus dans la ",
        "Footer_PrivacyPolicySuffix": "politique de confidentialité de ",
        "Footer_And": " et dans la ",
        "Footer_HubertPrivacyLink": "politique de confidentialité et les conditions générales de Hubert",
        "Chat_InterviewWith": "Entretien avec {{companyName}}",
        "Chat_StatusConnected": "Connecté",
        "Chat_StatusError": "Erreur",
        "Chat_StatusDisconnected": "Déconnecté",
        "Chat_StatusConnecting": "Connexion en cours...",
        "Chat_ReadyToStart": "Prêt à commencer l'entretien ?",
        "Chat_ButtonStart": "Commencer l'entretien",
        "Chat_SayHello": "Dites bonjour pour commencer la conversation.",
        "Chat_EmptyState": "Envoyez un message pour commencer l'entretien.",
        "Chat_SelectLanguage": "Choisissez votre langue",
        "Chat_Placeholder": "Tapez votre message...",
        "Chat_ButtonSend": "Envoyer",
        "Chat_ButtonBack": "Retour",
        "LoadingCandidateDetails": "Chargement des détails du candidat...",
        "FetchingCandidateDetails": "Récupération des détails du candidat...",
        "Chat_StatusReady": "En attente de connexion...",
        "Chat_ForbiddenError": "Cet entretien par chat n'est plus disponible.",
        "Chat_GeneralError": "Échec du démarrage du chat. Veuillez réessayer plus tard.",
        "Chat_SelectUiLanguage": "Langue du menu",
        "Chat_InterviewTitle": "Entretien d'embauche"
    }
}
